import useGoals from '@/composables/goal/goals';
import useParamDefaulter from '@/composables/view-params/default';
import useParamEnricher from '@/composables/view-params/enrich';
import useProperties from '@/composables/property/property';
import { computed, watch } from 'vue';
import { copy } from 'shared/lib/copy';
import { isNullOrUndefined } from 'shared/lib/object/object';

export default function useEnrichParams(repo) {
  const paramDefaulter = useParamDefaulter();
  const propertySvc = useProperties();
  const goalsSvc = useGoals();
  const paramEnricher = useParamEnricher(propertySvc, goalsSvc);

  watch(repo.views, (views) => {
    const toOperate = views.filter((v) => !(isNullOrUndefined(v.params) || isNullOrUndefined(v.params.filter)));

    const relations = toOperate.map((v) => paramEnricher.goalRelations(v.params.filter)).flat();
    paramEnricher.fetchGoals(relations);
  }, { immediate: true });

  const views = computed(() => repo.views.value.map((view) => {
    if (view.params === undefined) {
      return view;
    }

    let filter = view.params.filter;
    if (filter !== undefined && filter !== null) {
      filter = paramEnricher.enrich(copy(view.params.filter));
    }

    return {
      ...view,
      params: paramDefaulter.setDefaults({
        ...view.params,
        filter,
      }, view.viewType),
    };
  }));

  return {
    createLoading: repo.createLoading,
    createViews: repo.createViews,

    loadingUpdateView: repo.loadingUpdateView,
    updateView: repo.updateView,

    loadingDeleteView: repo.loadingDeleteView,
    deleteView: repo.deleteView,

    views,
  };
}
